require('./RAHireManagementPlanView.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKLink } = require('commonsComponents/OKLink');
const RACover = require('../../components/commons/RACover/RACover');
const RAFooter = require('../../components/commons/RAFooter/RAFooter');

// @components
const RAAccordionWizard = require('../../components/RAAccordionWizard/RAAccordionWizard');
const RAAccordionWizardStep = require('../../components/RAAccordionWizardStep/RAAccordionWizardStep');
const RAHireManagementPlanStep1 = require('../../components/RAHireManagementPlan/RAHireManagementPlanStep1/RAHireManagementPlanStep1');
const RAHireManagementPlanStep2 = require('../../components/RAHireManagementPlan/RAHireManagementPlanStep2/RAHireManagementPlanStep2');
const RAHireManagementPlanStep3 = require('../../components/RAHireManagementPlan/RAHireManagementPlanStep3/RAHireManagementPlanStep3');
const RAHireManagementPlanEmailConfigStep = require('../../components/RAHireManagementPlan/RAHireManagementPlanEmailConfigStep/RAHireManagementPlanEmailConfigStep');
const RAHireManagementPlanStep4 = require('../../components/RAHireManagementPlan/RAHireManagementPlanStep4/RAHireManagementPlanStep4');
const RAHireManagementPlanSuccess = require('../../components/RAHireManagementPlan/RAHireManagementPlanSuccess/RAHireManagementPlanSuccess');
const RAHireManagementPlanSuccessFooter = require('../../components/RAHireManagementPlan/RAHireManagementPlanSuccess/RAHireManagementPlanSuccessFooter');
const RAIndexRiskModal = require('../../components/RAIndexRiskModal/RAIndexRiskModal');
const RAInvestorProfile = require('../../components/RAInvestorProfile/RAInvestorProfile');
const RACommissionCondition = require('../../components/RACommissionCondition/RACommissionCondition');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const RARiskButton = require('../../components/RARiskButton/RARiskButton');
const RAErrorScreen = require('../../components/commons/RAErrorScreen/RAErrorScreen');
const {
    ModalUsPersonBlock,
} = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');

// @actions
const raHireManagementPlanActions = require('../../actions/RAHireManagementPlan');
const portfolioDistributionActions = require('../../actions/RAPortfolioDistribution');
const blockedAccountsActions = require('actions/blockedAccounts');
const suitabilityActions = require('../../actions/RASuitabilityTest');
const RAFeatureFlagActions = require('../../actions/RAFeatureFlag');
const raSimulationActions = require('../../actions/RASimulation');
const profileActions = require('actions/profile');
const preContractualMailInfoActions = require('actions/preContractualMailInfo');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { Portfolios } = require('../../utilities/RAPortfolioHelper');
const {
    recordLink,
    recordLinkV2,
    recordProcess,
    PROC_RA_CONTRACTS,
    PROC_START,
    PROC_STEP,
} = require('utilities/tagging');
const { base64ToBlob, downloadAsFile } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const BrowserUtils = require('utilities/browserUtils');

// @constants
const {
    CONTENT_TYPE_PDF,
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    FOURTH_STEP,
    FIFTH_STEP,
    BROKER_PG_URL,
    BROKER_PG_ROBO_URL,
} = require('constants/index');
const {
    MYPROFILE_BROKER_EDIT_URL,
    MYPROFILE_BROKER_ROBO_URL,
    PROC_RA_CONTRACTS_COST_SERVICE_MODAL,
    PROC_RA_CONTRACTS_FINAL_SELECTION,
    PROC_RA_CONTRACTS_WITH_FOUNDS,
    PROC_RA_CONTRACTS_WITH_MONEY,
    RA_INVESTMENT_TYPE_FOUNDS,
    WIZARD_POSITION_FIRST,
    WIZARD_POSITION_MIDDLE,
    WIZARD_POSITION_LAST,
} = require('../../raConstants/index');
const { HIRE_ROBO } = require('constants/operationCodesAccounts');
const {
    ROBO_PRECONTRACT,
    ROBO_ZERO_COMMISSION,
    ROBO_HIRE_WITH_TRANSFER,
    ROBO_SHOW_IMPLICIT_COSTS,
    EVIDENCE_WEALTH_ROBO_HIRING,
} = require('constants/flagBasedFeatures');

//@contact-center
const {
    canFinishOperative,
} = require('../../utilities/contactCenter/RACanFinishOperativeHelper');
const RAHireManagementPlanStep4CC = require('../../components/contactCenter/RAHireManagementPlan/RAHireManagementPlanStep4/RAHireManagementPlanStep4');
const SELECTED_VALUES = require('constants/contactCenter/brokerLegalConfirmationSelectedValues');
const NextButtonWrapper = require('components/contactCenter/nextButtonWrapper/nextButtonWrapper');
const RAHireManagementPlanLegalConfirmation = require('../../components/contactCenter/RAHireManagementPlan/RAHireManagementPlanLegalConfirmation/RAHireManagementPlanLegalConfirmation');

class RAHireManagementPlanView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayWizard: !__CONTACT_CENTER__,
            isModalOpen: false,
            selectedLegalConfirmationValue: SELECTED_VALUES.EMPTY,
        };

        this.buildModal = this.buildModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleRedirectToUserProfile = this.handleRedirectToUserProfile.bind(
            this,
        );
        this.handleAccountChange = this.handleAccountChange.bind(this);
        this.handleInvestmentAmountChange = this.handleInvestmentAmountChange.bind(
            this,
        );
        this.handleInvestmentTypeChange = this.handleInvestmentTypeChange.bind(
            this,
        );
        this.handleLegalYesNoOptionChange = this.handleLegalYesNoOptionChange.bind(
            this,
        );
        this.handleShowWizard = this.handleShowWizard.bind(this);
        this.hireManagementPlanSubmit = this.hireManagementPlanSubmit.bind(
            this,
        );
        this.handleOnContributionDayChange = this.handleOnContributionDayChange.bind(
            this,
        );
        this.handleOnLinkClick = this.handleOnLinkClick.bind(this);
        this.handleOnPeriodicityChange = this.handleOnPeriodicityChange.bind(
            this,
        );
        this.handleOnRecurringContributionChange = this.handleOnRecurringContributionChange.bind(
            this,
        );
        this.handleManagementPDFClickCC = this.handleManagementPDFClickCC.bind(
            this,
        );
        this.handlePDFDownload = this.handlePDFDownload.bind(this);
        this.handlePrintPdf = this.handlePrintPdf.bind(this);
        this.handleGetExplicitImplicitCosts = this.handleGetExplicitImplicitCosts.bind(
            this,
        );
        this.handleServiceCostsModalChange = this.handleServiceCostsModalChange.bind(
            this,
        );
        this.onValidateStep = this.onValidateStep.bind(this);
    }

    componentDidMount() {
        const {
            immSimulation,
            fetchFeatureFlag,
            getTestResult,
            getPDFContract,
            immAccounts,
            getBlockedAccounts,
            history,
            flagBasedFeatures,
        } = this.props;

        getBlockedAccounts(immAccounts.get('byId').toList(), HIRE_ROBO);

        if (!__CONTACT_CENTER__) {
            fetchFeatureFlag();
            const selectedStrategy = immSimulation.getIn([
                'simulation',
                'selectedPortfolio',
            ]);
            const objectiveType = immSimulation.getIn(['simulation', 'type']);
            let objective;
            if (!!objectiveType) {
                objective = objectiveType;
            } else {
                objective = 'sin objetivo';
            }

            const eventTag =
                'robo cartera ' + selectedStrategy + ' ' + objective;
            const customData = {
                processDetail: eventTag,
            };

            recordProcess(PROC_RA_CONTRACTS, PROC_START, customData);
            recordLink(
                PROC_RA_CONTRACTS,
                PROC_STEP + 1 + '_contrato',
                eventTag,
            );
        } else {
            getTestResult();
            if (!flagBasedFeatures.get(EVIDENCE_WEALTH_ROBO_HIRING)) {
                getPDFContract(history, !__CONTACT_CENTER__);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const {
            immHireManagementPlan,
            immSimulation,
            match: {
                params: { objective },
            },
            history,
        } = this.props;
        const immPrevimmSimulation = prevProps.immSimulation;
        const finishedFetching =
            immSimulation.get('success') &&
            !immPrevimmSimulation.get('success');
        if (finishedFetching) {
            this.props.requestPortfolioDistribution();
            const immSimulationData = immSimulation.get('simulation');
            this.props.setInvestmentAmount(
                immSimulationData.get('initialContribution'),
            );
            if (immSimulationData.get('hasRecurringTransfer')) {
                this.props.setPeriodicity(
                    immSimulationData.getIn([
                        'recurringTransfer',
                        'frequencyCode',
                    ]),
                );
                this.props.setRecurringContributionAmount(
                    immSimulationData.getIn(['recurringTransfer', 'amount']),
                );
                this.props.setContributionDay(
                    immSimulationData.getIn(['recurringTransfer', 'cutDay']),
                );
            }
            this.props.getExplicitImplicitCosts(
                immSimulationData.get('selectedPortfolio'),
                immSimulationData.get('initialContribution'),
                history,
            );
        }

        const prevVisibleStep = prevProps.immHireManagementPlan.get(
            'visibleStep',
        );
        const nextVisibleStep = immHireManagementPlan.get('visibleStep');
        if (prevVisibleStep !== nextVisibleStep) {
            const selectedStrategy = immSimulation.getIn([
                'simulation',
                'selectedPortfolio',
            ]);
            let selectedObjective;
            if (!!objective) {
                selectedObjective = immSimulation.getIn(['simulation', 'type']);
            } else {
                selectedObjective = 'sin objetivo';
            }
            const customData = {
                event_name: 'event_success',
                action: 'success',
                format: 'steps',
                component: 'funnel',
            };
            const elementByStep = [
                'investmentDetails',
                'periodicContribution',
                'bankDetails',
            ];
            if (nextVisibleStep === 1) {
                const typeSelected =
                    immHireManagementPlan.getIn([
                        'steps',
                        FIRST_STEP,
                        'investmentType',
                    ]) === RA_INVESTMENT_TYPE_FOUNDS
                        ? PROC_RA_CONTRACTS_WITH_FOUNDS
                        : PROC_RA_CONTRACTS_WITH_MONEY;
                recordLinkV2({
                    eventCategory: PROC_RA_CONTRACTS,
                    categoriaEvento: PROC_RA_CONTRACTS,
                    eventAction: PROC_STEP + nextVisibleStep + '_contrato',
                    accionEvento: PROC_STEP + nextVisibleStep + '_contrato',
                    eventLabel:
                        PROC_RA_CONTRACTS_FINAL_SELECTION + typeSelected,
                    etiquetaEvento:
                        PROC_RA_CONTRACTS_FINAL_SELECTION + typeSelected,
                    element: 'investmentDetails',
                    ...customData,
                });
            } else {
                const eventTag =
                    'robo cartera ' +
                    selectedStrategy +
                    ' ' +
                    selectedObjective;
                const eventAction =
                    PROC_STEP +
                    (nextVisibleStep === 4
                        ? nextVisibleStep
                        : nextVisibleStep + 1) +
                    '_contrato';
                recordLinkV2({
                    eventCategory: PROC_RA_CONTRACTS,
                    categoriaEvento: PROC_RA_CONTRACTS,
                    accionEvento: eventAction,
                    etiquetaEvento: eventTag,
                    eventLabel: eventTag,
                    element: elementByStep[prevVisibleStep],
                    eventAction,
                    ...customData,
                });
            }
        }
        if (
            prevVisibleStep === FIRST_STEP &&
            nextVisibleStep !== FIRST_STEP &&
            immHireManagementPlan.get('fundsTotalAmount') > 0
        ) {
            this.props.getExplicitImplicitCosts(
                immSimulation.getIn(['simulation', 'selectedPortfolio']),
                immHireManagementPlan.get('fundsTotalAmount'),
                history,
            );
        }

        const visibleStep = immHireManagementPlan.get('visibleStep');
        const portfolioCustomName = immSimulation.getIn([
            'simulation',
            'displayName',
        ]);
        const newCustomData = {
            event_name: 'step_investment_details',
            pageName: `/contractingRobo/step${visibleStep +
                1}/investmentDetails`,
            sectionFamily: 'wealth',
            sectionCategory: 'products',
            sectionName: 'robo',
            serviceType: 'productContracting',
            interactionType: 'funnel',
            processType: 'contractingRobo',
            processStep: `step${visibleStep + 1}`,
            processDetail: 'investmentDetails',
            productName: portfolioCustomName,
        };

        if (visibleStep !== prevVisibleStep) {
            window &&
                window.utag &&
                window.utag.view &&
                window.utag.view(newCustomData);

            recordLinkV2({
                event_name: 'event_success',
                action: 'success',
                format: 'steps',
                component: 'funnel',
                element: 'productDetails',
            });
        }
    }

    componentWillUnmount() {
        if (__CONTACT_CENTER__) {
            this.props.reset();
            this.props.resetPreContractualMail();
            this.props.resetSuitabilityTest();
            this.props.resetBlockedAccounts();
        }
    }

    handleServiceCostsModalChange(event) {
        recordLink(
            PROC_RA_CONTRACTS,
            PROC_RA_CONTRACTS_COST_SERVICE_MODAL,
            event,
        );
    }

    handleGetExplicitImplicitCosts(value) {
        const { getExplicitImplicitCosts, immSimulation, history } = this.props;
        getExplicitImplicitCosts(
            immSimulation.getIn(['simulation', 'selectedPortfolio']),
            value,
            history,
        );
    }

    handleInvestmentTypeChange(type) {
        const event =
            type === RA_INVESTMENT_TYPE_FOUNDS
                ? PROC_RA_CONTRACTS_WITH_FOUNDS
                : PROC_RA_CONTRACTS_WITH_MONEY;
        recordLink(PROC_RA_CONTRACTS, PROC_STEP + 1 + '_contrato', event);
    }

    handleInvestmentAmountChange(value) {
        const {
            setInvestmentAmount,
            getExplicitImplicitCosts,
            immSimulation,
            history,
        } = this.props;
        const selectedPortfolioId = immSimulation.getIn([
            'simulation',
            'selectedPortfolio',
        ]);
        setInvestmentAmount(value);
        getExplicitImplicitCosts(selectedPortfolioId, value, history);
    }

    handleAccountChange(accountId) {
        const accountBalance = this.props.immAccounts.getIn([
            'byId',
            accountId,
            'balances',
            'availableBalance',
        ]);
        const originCountry = this.props.immProfile.get('originCountry');
        this.props.setSelectedAccount(accountId, accountBalance, originCountry);
    }

    handleManagementPDFClickCC() {
        const documentContent = this.props.immHireManagementPlan.get('pdfLink');
        const base64String = `data:${CONTENT_TYPE_PDF};base64,${documentContent}`;
        downloadAsFile(
            base64ToBlob(base64String),
            CONTENT_TYPE_PDF,
            `Contrato GD.pdf`,
        ); // TBC: Filename
    }

    handlePDFDownload() {
        const { flagBasedFeatures } = this.props;
        let documentContent;
        if (flagBasedFeatures.get(ROBO_PRECONTRACT)) {
            documentContent = this.props.immHireManagementPlan.get('pdfConcat');
        } else {
            documentContent = this.props.immHireManagementPlan.get('pdfLink');
        }
        const fileName = formatText(
            'raHireManagementPlanStep4-raHireManagementPlanStep4_downloadPDFName',
        );
        downloadAsFile(
            base64ToBlob(documentContent),
            CONTENT_TYPE_PDF,
            `${fileName}.pdf`,
        );
    }

    handlePrintPdf() {
        const { immHireManagementPlan, flagBasedFeatures } = this.props;
        if (BrowserUtils.browserIsIE()) {
            let documentContent;
            if (flagBasedFeatures.get(ROBO_PRECONTRACT)) {
                documentContent = immHireManagementPlan.get('pdfConcat');
            } else {
                documentContent = immHireManagementPlan.get('pdfLink');
            }
            const data = [base64ToBlob(documentContent)];
            const blobObject = new Blob(data, {
                type: `${CONTENT_TYPE_PDF};base64`,
            });
            window.navigator.msSaveOrOpenBlob(blobObject);
        } else {
            let concatURL;
            if (flagBasedFeatures.get(ROBO_PRECONTRACT)) {
                concatURL = immHireManagementPlan.get('pdfConcatURL');
            } else {
                concatURL = immHireManagementPlan.get('pdfContent');
            }
            const winparams = `dependent=yes,locationbar=no,scrollbaars=yes,menubar=yes,resizable,screenX=50,screenY=50,width=${screen.width},height=${screen.height}`;
            const printWindow = window.open(concatURL, '', winparams);
            printWindow.print();
        }
    }

    handleShowWizard() {
        this.setState({
            displayWizard: true,
        });
    }

    handleLegalYesNoOptionChange(value) {
        this.setState({
            selectedLegalConfirmationValue: value,
        });
    }

    handleLinkClickEvt(evt, action) {
        evt.preventDefault();
        evt.stopPropagation();
        action();
    }

    isAbleToContinue() {
        return (
            __CONTACT_CENTER__ &&
            this.state.selectedLegalConfirmationValue === SELECTED_VALUES.YES
        );
    }

    getBreadcrumb() {
        const title = formatText(
            'raHireManagementPlan-nonObjectiveHireServiceBreadcrumb',
        );

        return [
            {
                text: formatText('raManagementPlan-investments'),
                url: BROKER_PG_URL,
            },
            {
                text: formatText('raManagementPlan-managementPlanBreadcrumb'),
                url: MYPROFILE_BROKER_ROBO_URL,
            },
            {
                text: title,
            },
        ];
    }

    getHeaderTitle(isObjective, portfolioCustomName) {
        let headerTitle;

        if (isObjective) {
            headerTitle = formatText(
                'raHireManagementPlan-objectiveHeaderTitle',
            );
        } else {
            headerTitle = (
                <FormattedText
                    value="raHireManagementPlan-nonObjectiveHeaderTitle"
                    injectedStrings={[portfolioCustomName]}
                />
            );
        }

        return headerTitle;
    }

    handleOnPeriodicityChange(ev) {
        this.props.setPeriodicity(ev.value);
    }

    handleOnContributionDayChange(ev) {
        const { immHireManagementPlan } = this.props;
        const selectedDay = parseInt(ev.currentTarget.dataset.id);
        const visibleStep = immHireManagementPlan.get('visibleStep');
        if (
            selectedDay !==
            immHireManagementPlan.getIn([
                'steps',
                visibleStep,
                'contributionDay',
            ])
        ) {
            this.props.setContributionDay(selectedDay);
        }
    }

    handleOnRecurringContributionChange(value) {
        this.props.setRecurringContributionAmount(value);
    }

    hireManagementPlanSubmit() {
        const {
            history,
            match: {
                params: { objective },
            },
        } = this.props;
        recordLinkV2({
            event_name: 'event_success',
            action: 'success',
            format: 'steps',
            component: 'funnel',
            element: 'otp',
        });
        this.props.finish(history, !!objective);
    }

    buildClientEmailConfigurationStep(
        isFourthStepActive,
        immProfile,
        immProfileEditor,
        configureUserEmail,
        immHireManagementPlan,
    ) {
        return (
            <RAAccordionWizardStep
                activateOnClickOfAccordion={true}
                position={WIZARD_POSITION_MIDDLE}
                title={formatText(
                    'raHireManagementPlan-emailConfigurationTitle',
                )}
                icon="icon-correo"
            >
                <RAHireManagementPlanEmailConfigStep
                    active={isFourthStepActive}
                    immProfile={immProfile}
                    immProfileEditor={immProfileEditor}
                    configureUserEmail={configureUserEmail}
                    immSteps={immHireManagementPlan.get('steps')}
                />
            </RAAccordionWizardStep>
        );
    }

    onValidateStep = e => {
        const { history, validateStep } = this.props;
        validateStep(e, history);
    };

    buildAccordionWizard() {
        const {
            changeTransferFundsAccount,
            changeInvestmentType,
            flagBasedFeatures,
            immAccounts,
            immGlobalPosition,
            immHireManagementPlan,
            immPrinter,
            immProfile,
            immProfileEditor,
            toggleDisclaimer,
            immSignaturePattern,
            immSimulation,
            configureUserEmail,
            match: {
                params: { objective },
            },
            updateSelectedAccountsWithFunds,
            updateSelectedFundsTotal,
            validateStep,
            immGlobalVariables,
            immCheckStatus,
            getHirePlanConfirmationPDF,
            saveTermsAndConditions,
        } = this.props;
        const hasObjective = !!objective;
        const isFirstStepActive =
            immHireManagementPlan.get('visibleStep') === FIRST_STEP;
        const isSecondStepActive =
            immHireManagementPlan.get('visibleStep') === SECOND_STEP;
        const isThirdStepActive =
            immHireManagementPlan.get('visibleStep') === THIRD_STEP;
        const isFourthStepActive =
            immHireManagementPlan.get('visibleStep') === FOURTH_STEP;
        const isFifthStepActive =
            immHireManagementPlan.get('visibleStep') === FIFTH_STEP;
        const finishDisabled = __CONTACT_CENTER__
            ? !canFinishOperative(immSignaturePattern, immPrinter)
            : !immSignaturePattern.get('inputValueSMS');
        const isLoading =
            immHireManagementPlan.get('isFetching') ||
            immSignaturePattern.get('isFetchingSMSCode');
        const isClientEmailConfigured = !!PersonalDataHelper.getEmail(
            immProfile,
        );
        const thirdStepTitle = formatText(
            'raHireManagementPlan-raHireManagementPlan_asociatedAccountTitle',
        );
        const commissionCondition =
            flagBasedFeatures.get(ROBO_ZERO_COMMISSION) &&
            immCheckStatus.get('zeroCommission');

        let clientEmailConfigurationStep;

        if (!isClientEmailConfigured) {
            clientEmailConfigurationStep = this.buildClientEmailConfigurationStep(
                isFourthStepActive,
                immProfile,
                immProfileEditor,
                configureUserEmail,
                immHireManagementPlan,
            );
        }
        const raHireManagementPlanStep3 = (
            <RAAccordionWizardStep
                activateOnClickOfAccordion={true}
                position={WIZARD_POSITION_MIDDLE}
                title={thirdStepTitle}
                icon="icon-depositos"
            >
                <RAHireManagementPlanStep3
                    active={isThirdStepActive}
                    immAccounts={immAccounts}
                    immProfile={immProfile}
                    immSteps={immHireManagementPlan.get('steps')}
                    immSelectedAccountsWithFunds={immHireManagementPlan.get(
                        'selectedAccountsWithFunds',
                    )}
                    onAccountChange={this.handleAccountChange}
                />
            </RAAccordionWizardStep>
        );

        return (
            <RAAccordionWizard
                immSteps={immHireManagementPlan.get('steps')}
                cancelPath={MYPROFILE_BROKER_ROBO_URL}
                finish={this.hireManagementPlanSubmit}
                resetStep={this.props.resetStep}
                setVisibleStep={this.props.setVisibleStep}
                validateStep={this.onValidateStep}
                visibleStep={immHireManagementPlan.get('visibleStep')}
                immProfile={immProfile}
            >
                <RAAccordionWizardStep
                    position={WIZARD_POSITION_FIRST}
                    title={formatText(
                        'raHireManagementPlan-raHireManagementPlan_step1Title',
                    )}
                    activateOnClickOfAccordion={true}
                    icon="icon-imprevistos"
                    valid={true}
                >
                    <RAHireManagementPlanStep1
                        accountOwner={immProfile.get('nombreCompleto')}
                        availableAccountsWithFunds={immGlobalPosition.get(
                            'availableAccountsWithFunds',
                        )}
                        fundsTotalAmount={immHireManagementPlan.get(
                            'fundsTotalAmount',
                        )}
                        selectedAccountsWithFunds={immHireManagementPlan.get(
                            'selectedAccountsWithFunds',
                        )}
                        updateSelectedAccountsWithFunds={
                            updateSelectedAccountsWithFunds
                        }
                        updateSelectedFundsTotal={updateSelectedFundsTotal}
                        annualCost={immHireManagementPlan.get(
                            'annualCostExclVat',
                        )}
                        changeInvestmentType={changeInvestmentType}
                        changeTransferFundsAccount={changeTransferFundsAccount}
                        productCost={immHireManagementPlan.get('productCost')}
                        active={isFirstStepActive}
                        hasFounds={immGlobalPosition.get('canHireWithFounds')}
                        immSteps={immHireManagementPlan.get('steps')}
                        initialAmountSimulated={immSimulation.getIn([
                            'simulation',
                            'initialContribution',
                        ])}
                        immAccounts={immAccounts}
                        onServiceCostsModalChange={
                            this.handleServiceCostsModalChange
                        }
                        onInvestmentTypeChange={this.handleInvestmentTypeChange}
                        onInvestmentAmountChange={
                            this.handleInvestmentAmountChange
                        }
                        commisionCondition={commissionCondition}
                        enableHireWithTransfer={flagBasedFeatures.get(
                            ROBO_HIRE_WITH_TRANSFER,
                        )}
                        setSelectedAccount={this.props.setSelectedAccount}
                        handleGetExplicitImplicitCosts={
                            // eslint-disable-line
                            this.handleGetExplicitImplicitCosts
                        }
                        showImplicitCost={flagBasedFeatures.get(
                            ROBO_SHOW_IMPLICIT_COSTS,
                        )}
                    />
                </RAAccordionWizardStep>
                <RAAccordionWizardStep
                    activateOnClickOfAccordion={true}
                    position={WIZARD_POSITION_MIDDLE}
                    title={formatText('raHireManagementPlan-step2Periodica')}
                    optionalTitle={formatText(
                        'raHireManagementPlan-optionalTitle',
                    )}
                    optionalTitleClassName="ra-hire-management-plan-view__container-optional-title"
                    icon="icon-incremento-moderado"
                    id="second"
                >
                    <RAHireManagementPlanStep2
                        activateOnClickOfAccordion={true}
                        active={isSecondStepActive}
                        immAccounts={immAccounts}
                        immProfile={immProfile}
                        immSteps={immHireManagementPlan.get('steps')}
                        onAccountChange={this.handleAccountChange}
                        onContributionDayChange={
                            this.handleOnContributionDayChange
                        }
                        onPeriodicityChange={this.handleOnPeriodicityChange}
                        onRecurringContributionChange={
                            this.handleOnRecurringContributionChange
                        }
                        validateCalendarStep={this.props.validateCalendarStep}
                    />
                </RAAccordionWizardStep>
                {raHireManagementPlanStep3}
                {clientEmailConfigurationStep}
                <RAAccordionWizardStep
                    activateOnClickOfAccordion={true}
                    position={WIZARD_POSITION_LAST}
                    title={
                        __CONTACT_CENTER__
                            ? formatText('raHireManagementPlanStep4-title')
                            : formatText('raHireManagementPlan-step3Title')
                    }
                    icon="icon-firma"
                    finishDisabled={finishDisabled}
                    loading={isLoading}
                >
                    {!__CONTACT_CENTER__ && (
                        <RAHireManagementPlanStep4
                            active={isFifthStepActive}
                            immAccounts={immAccounts}
                            immHireManagementPlan={
                                this.props.immHireManagementPlan
                            }
                            immProfile={immProfile}
                            immSteps={immHireManagementPlan.get('steps')}
                            toggleDisclaimer={toggleDisclaimer}
                            getPDFContract={this.props.getPDFContract}
                            onDownloadPDF={this.handlePDFDownload}
                            onPrintPDF={this.handlePrintPdf}
                            enableDisclaimerCheck={
                                this.props.enableDisclaimerCheck
                            }
                            isClientEmailConfigured={isClientEmailConfigured}
                            isSignaturePatternUnable={this.props.immHireManagementPlan.get(
                                'displaySignaturePattern',
                            )}
                            flagBasedFeatures={flagBasedFeatures}
                            immGlobalVariables={immGlobalVariables}
                            saveTermsAndConditions={saveTermsAndConditions}
                        />
                    )}
                    {__CONTACT_CENTER__ && (
                        <RAHireManagementPlanStep4CC
                            active={isFifthStepActive}
                            immAccounts={immAccounts}
                            immProfile={immProfile}
                            immSimulation={immSimulation}
                            immHireManagementPlan={immHireManagementPlan}
                            availableAccountsWithFunds={immGlobalPosition.get(
                                'availableAccountsWithFunds',
                            )}
                            hasObjective={hasObjective}
                            immSteps={immHireManagementPlan.get('steps')}
                            productCost={immHireManagementPlan.get(
                                'productCost',
                            )}
                            validate={validateStep}
                            toggleDisclaimer={toggleDisclaimer}
                            getPDFContract={this.props.getPDFContract}
                            pdfLink={this.props.immHireManagementPlan.get(
                                'pdfLink',
                            )}
                            enableDisclaimerCheck={
                                this.props.enableDisclaimerCheck
                            }
                            isSignaturePatternUnable={this.props.immHireManagementPlan.get(
                                'displaySignaturePattern',
                            )}
                            getHirePlanConfirmationPDF={
                                getHirePlanConfirmationPDF
                            }
                            flagBasedFeatures={flagBasedFeatures}
                        />
                    )}
                </RAAccordionWizardStep>
            </RAAccordionWizard>
        );
    }

    buildManagementButtonCC() {
        const {
            immGlobalPosition,
            immGlobalVariables,
            flagBasedFeatures,
        } = this.props;
        const hasRoboHired = immGlobalPosition.get('hasRoboHired');
        const precontractURL =
            immGlobalVariables.getIn([
                'parameters',
                'contratos',
                'precontractuales_robo',
            ]) || '';
        const valueFormattedText = hasRoboHired
            ? 'raHireManagementPlan-legalConfirmationAttachedManagementPlanContract'
            : 'raHireManagementPlan-legalConfirmationManagementPlanContract';

        const links = [
            <OKLink
                modifier="emphasize"
                key={0}
                onClick={evt => {
                    this.handleLinkClickEvt(
                        evt,
                        this.handleManagementPDFClickCC,
                    );
                }}
            >
                <FormattedText value={valueFormattedText} />
            </OKLink>,
            ...(flagBasedFeatures.get(ROBO_PRECONTRACT) ? (
                <OKLink
                    modifier="emphasize"
                    key={1}
                    to={precontractURL}
                    target="_blank"
                >
                    <FormattedText value="raHireManagementPlan-legalConfirmationManagementPlanPrecontract" />
                </OKLink>
            ) : (
                []
            )),
        ];

        if (!hasRoboHired) {
            return links;
        }

        return links[0];
    }

    buildFirstHireDocumentsAvailabilityBlock() {
        const { immProfile } = this.props;
        const managementButton = this.buildManagementButtonCC();
        const originCountry = immProfile.get('originCountry');
        const textKey = `raHireManagementPlan-legalConfirmationFirstHireDocumentsText2_${originCountry}`;

        return (
            <div>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireDocumentsAvailability1" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph ra-hire-management-plan-view__legal-confirmation-paragraph--last">
                    <FormattedTextWithComponents
                        value={textKey}
                        injectedComponents={[...managementButton]}
                    />
                </p>
            </div>
        );
    }

    buildRoboHiredDocumentsAvailabilityBlock() {
        const managementButton = this.buildManagementButtonCC();

        return (
            <div>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph ra-hire-management-plan-view__legal-confirmation-paragraph--last">
                    <FormattedTextWithComponents
                        value="raHireManagementPlan-legalConfirmationHasHireDocumentsAvailability1"
                        injectedComponents={[managementButton]}
                    />
                </p>
            </div>
        );
    }

    buildDocumentsAvailabilityBlock() {
        const { immGlobalPosition } = this.props;

        if (!immGlobalPosition.get('hasRoboHired')) {
            return this.buildFirstHireDocumentsAvailabilityBlock();
        } else {
            return this.buildRoboHiredDocumentsAvailabilityBlock();
        }
    }

    buildFirstHireProductDescriptionBlock() {
        return (
            <div>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireProductDescription1" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireProductDescription2" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireProductDescription3" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireProductDescription4" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireProductDescription5" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationFirstHireProductDescription6" />
                </p>
                <ul className="ra-hire-management-plan-view__legal-confirmation-list">
                    <FormattedText value="cc_raCommons-serviceFee" />
                </ul>
            </div>
        );
    }

    buildRoboHiredExternalProductDescriptionBlock() {
        return (
            <BlockInfo extraClass="ra-hire-management-plan-view__block-info-hired-products">
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription1" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription2" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription3" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription4" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription5" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription6" />
                </p>
                <ul className="ra-hire-management-plan-view__legal-confirmation-list">
                    <FormattedText value="cc_raCommons-serviceFee" />
                </ul>
            </BlockInfo>
        );
    }

    buildProductDescriptionBlock() {
        const { immGlobalPosition } = this.props;

        if (!immGlobalPosition.get('hasRoboHired')) {
            return this.buildFirstHireProductDescriptionBlock();
        } else {
            return this.buildRoboHiredProductDescriptionBlock();
        }
    }

    buildRoboHiredProductDescriptionBlock() {
        return (
            <div>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription8" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription9" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription10" />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph ra-hire-management-plan-view__legal-confirmation-paragraph--last">
                    <FormattedText value="raHireManagementPlan-legalConfirmationHasHireProductDescription11" />
                </p>
            </div>
        );
    }

    buildFirstHireLegalQuestionBlock() {
        const { immProfile } = this.props;

        const managementButton = this.buildManagementButtonCC();
        const fullname = immProfile.get('fullname');
        const originCountry = immProfile.get('originCountry');
        const firstHireQuestionText = `raHireManagementPlan-legalConfirmationFirstHireQuestionText1_${originCountry}`;

        return (
            <div>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedTextWithComponents
                        value={firstHireQuestionText}
                        injectedComponents={[...managementButton]}
                    />
                </p>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedText
                        value="raHireManagementPlan-legalConfirmationFirstHireQuestion2"
                        injectedStrings={[fullname]}
                    />
                </p>
            </div>
        );
    }

    buildRoboHiredLegalQuestionBlock() {
        const managementButton = this.buildManagementButtonCC();

        return (
            <div>
                <p className="ra-hire-management-plan-view__legal-confirmation-paragraph">
                    <FormattedTextWithComponents
                        value="raHireManagementPlan-legalConfirmationHasHireQuestion1"
                        injectedComponents={[managementButton]}
                    />
                </p>
            </div>
        );
    }

    buildLegalQuestionBlock() {
        const { immGlobalPosition } = this.props;

        if (!immGlobalPosition.get('hasRoboHired')) {
            return this.buildFirstHireLegalQuestionBlock();
        } else {
            return this.buildRoboHiredLegalQuestionBlock();
        }
    }

    buildLegalConfirmation() {
        const {
            immPreContractualMail,
            immProfile,
            requestProfile,
            sendMail,
            immGlobalPosition,
            immHireManagementPlan,
            flagBasedFeatures,
        } = this.props;
        const documentsAvailability = this.buildDocumentsAvailabilityBlock();
        const productDescription = this.buildProductDescriptionBlock();
        const legalQuestion = this.buildLegalQuestionBlock();
        const clientEmailAddress = PersonalDataHelper.getEmail(immProfile);
        const refreshEmailAddressError = immProfile.get('error')
            ? immProfile.getIn(['error', 'description'], 'Error')
            : undefined;
        const hasRoboHired = immGlobalPosition.get('hasRoboHired');

        return (
            <NextButtonWrapper
                buttonContainerClassName="ra-hire-management-plan-view__legal-confirmation-next-button"
                canContinue={this.isAbleToContinue()}
                childrenHaveDependencies={false}
                onContinue={this.handleShowWizard}
            >
                <section>
                    {hasRoboHired &&
                        this.buildRoboHiredExternalProductDescriptionBlock()}
                    <RAHireManagementPlanLegalConfirmation
                        className="ra-hire-management-plan-view__legal-confirmation"
                        clientEmailAddress={clientEmailAddress}
                        documentsAvailability={documentsAvailability}
                        immPreContractualMail={immPreContractualMail}
                        legalQuestion={legalQuestion}
                        onYesNoOptionChange={this.handleLegalYesNoOptionChange}
                        productDescription={productDescription}
                        refreshEmailAddress={requestProfile}
                        refreshEmailAddressError={refreshEmailAddressError}
                        selectedYesNoOption={
                            this.state.selectedLegalConfirmationValue
                        }
                        sendMail={sendMail}
                        immHireManagementPlan={immHireManagementPlan}
                        flagBasedFeatures={flagBasedFeatures}
                    />
                </section>
            </NextButtonWrapper>
        );
    }

    buildWizardSection(immAssetAllocations) {
        const {
            immHireManagementPlan,
            immPortfolioDistribution,
            immSimulation,
            match: {
                params: { objective },
            },
            immSuitabilityTest,
        } = this.props;
        const wizard = this.state.displayWizard
            ? this.buildAccordionWizard(objective)
            : this.buildLegalConfirmation();
        const selectedPortfolioId = immSimulation.getIn([
            'simulation',
            'selectedPortfolio',
        ]);
        const initialContributionAmount = immHireManagementPlan.getIn([
            'steps',
            FIRST_STEP,
            'investmentAmount',
        ]);
        const immResults = immSuitabilityTest.getIn(['results', 0]);
        let content = <LoadingSection />;
        const isResultLoaded =
            !immSuitabilityTest.get('isFetchingResults') &&
            immSuitabilityTest.get('results');
        const isPortfolioDistributionLoaded =
            !immPortfolioDistribution.get('isFetching') && immAssetAllocations;
        if (isResultLoaded && isPortfolioDistributionLoaded) {
            content = (
                <RAInvestorProfile
                    immAssetAllocations={immAssetAllocations}
                    immResults={immResults}
                    immSimulation={immSimulation.get('simulation')}
                    hasObjective={!!objective}
                    selectedPortfolioId={selectedPortfolioId}
                    initialContributionAmount={initialContributionAmount}
                />
            );
        }

        return (
            <div className="ra-hire-management-plan-view__wizard-section">
                <div className="ra-hire-management-plan-view__section">
                    {content}
                </div>
                <div
                    id="printable-wizard"
                    className="ra-hire-management-plan-view__wizard"
                >
                    {wizard}
                </div>
            </div>
        );
    }

    buildSuccessfulSection(
        immAssetAllocations,
        immHireManagementPlan,
        immHiringFlowData,
        immSuitabilityTest,
        hasObjective,
        investProfileValue,
    ) {
        const { immGlobalPosition } = this.props;
        const investorProfile = immSuitabilityTest.getIn([
            'results',
            0,
            'clientRiskProfileTitle',
        ]);
        const investorProfileDescription = immSuitabilityTest.getIn([
            'results',
            0,
            'clientRiskProfileDescription',
        ]);
        const simulationData = immHiringFlowData.get('simulation');

        return (
            <RAHireManagementPlanSuccess
                immAssetAllocations={immAssetAllocations}
                immHireManagementPlan={immHireManagementPlan}
                immHiringFlowData={simulationData}
                hasObjective={hasObjective}
                investorProfile={investorProfile}
                investorProfileDescription={investorProfileDescription}
                investProfileValue={investProfileValue}
                availableAccountsWithFunds={immGlobalPosition.get(
                    'availableAccountsWithFunds',
                )}
            />
        );
    }

    buildModal() {
        return (
            <RAIndexRiskModal
                isModalOpen={this.state.isModalOpen}
                onModalClose={this.handleCloseModal}
            />
        );
    }

    handleCloseModal() {
        this.setState({
            isModalOpen: false,
        });
    }

    handleRedirectToUserProfile() {
        this.props.history.push(MYPROFILE_BROKER_EDIT_URL);
    }

    handleOnLinkClick() {
        this.setState({
            isModalOpen: true,
        });
    }

    buildEmailErrorScreen() {
        const mappingBreadcrumb = this.getBreadcrumb();
        const errorHeading = 'raHireManagementPlan-emailErrorStatementHeading';
        const mainButton = {
            label: formatText('raHireManagementPlan-invertimosPortiButton'),
            url: MYPROFILE_BROKER_ROBO_URL,
        };
        const secondaryButton = {
            label: formatText('raHireManagementPlan-datosPersonalesButton'),
            url: MYPROFILE_BROKER_EDIT_URL,
        };

        return (
            <RAErrorScreen
                mappingBreadcrumb={mappingBreadcrumb}
                heading={errorHeading}
                mainButton={mainButton}
                secondaryButton={secondaryButton}
            >
                <div className="ra-hire-management-plan-view__container-description-statement">
                    <FormattedText value="raHireManagementPlan-emailErrorStatementTitle" />
                </div>
                <p className="ra-hire-management-plan-view__container-description-text">
                    <FormattedText value="raHireManagementPlan-emailErrorStatementOne" />
                    <OKLink
                        extraClass="ra-hire-management-plan-view__container-description-link"
                        onClick={this.handleRedirectToUserProfile}
                    >
                        <FormattedText value="raHireManagementPlan-datosPersonalesLinkText" />
                    </OKLink>
                    <FormattedText value="raHireManagementPlan-emailErrorStatementTwo" />
                    <FormattedText
                        value="raHireManagementPlan-emailErrorStatementThree"
                        className="ra-hire-management-plan-view__container-description-text--highlighted"
                    />
                    <div>
                        <FormattedText value="raHireManagementPlan-emailErrorStatementFour" />
                    </div>
                </p>
            </RAErrorScreen>
        );
    }

    render() {
        const {
            immHireManagementPlan,
            immPortfolioDistribution,
            immSuitabilityTest,
            immSimulation,
            flagBasedFeatures,
            match: {
                params: { objective },
            },
            immCheckStatus,
        } = this.props;
        const hasObjective = !!objective;
        const investProfileValue = immSimulation.getIn([
            'simulation',
            'selectedPortfolio',
        ]);
        const displayErrorScreen = immHireManagementPlan.get(
            'displayErrorScreen',
        );
        if (!immSimulation.get('success') && investProfileValue <= 0) {
            return <LoadingSection />;
        }

        const immAssetAllocations = immPortfolioDistribution.getIn([
            'portfolio',
            investProfileValue.toString(),
            'assetAllocations',
        ]);
        const submitSuccessful = immHireManagementPlan.get('submitSuccessful');
        const mappingBreadcrumb = this.getBreadcrumb();
        const portfolioCustomName = immSimulation.getIn([
            'simulation',
            'displayName',
        ]);
        const headerTitle = this.getHeaderTitle(objective, portfolioCustomName);
        const goalType = objective
            ? immSimulation.getIn(['simulation', 'type'])
            : '';
        let content;
        let rightContent;
        let footer;
        let successFooter;

        if (submitSuccessful) {
            content = this.buildSuccessfulSection(
                immAssetAllocations,
                immHireManagementPlan,
                immSimulation,
                immSuitabilityTest,
                hasObjective,
                investProfileValue,
            );
            successFooter = <RAHireManagementPlanSuccessFooter />;
        } else {
            content = this.buildWizardSection(immAssetAllocations);
            rightContent = (
                <RARiskButton
                    modifier="ghost"
                    inverse={true}
                    onClick={this.handleOnLinkClick}
                />
            );
            footer = <RAFooter cancelPath={MYPROFILE_BROKER_ROBO_URL} />;
        }
        let iconTitle;
        if (!objective) {
            const portfolio = Portfolios[investProfileValue];
            iconTitle = (
                <img
                    className="ra-hire-management-plan-view__icon"
                    src={portfolio.icon}
                />
            );
        }
        const modal = this.state.isModalOpen ? this.buildModal() : null;
        let commisionCondition;
        if (
            flagBasedFeatures.get(ROBO_ZERO_COMMISSION) &&
            immCheckStatus.get('zeroCommission')
        ) {
            commisionCondition = (
                <div className="ra-hire-management-plan-view__conditions">
                    <RACommissionCondition showImage={false} />
                </div>
            );
        }

        let contentSection;

        if (displayErrorScreen) {
            contentSection = this.buildEmailErrorScreen();
        } else {
            contentSection = (
                <React.Fragment>
                    <div className="container-fluid">
                        <div className="row">
                            <RACover
                                breadcrumb={mappingBreadcrumb}
                                success={submitSuccessful}
                                successTitle={formatText(
                                    'raHireManagementPlanSuccess-raHireManagementPlanSuccess_headerSuccessTitle',
                                )}
                                title={headerTitle}
                                showHelp={true}
                                helpContent={rightContent}
                                iconTitle={iconTitle}
                                goalType={goalType}
                            />
                        </div>
                    </div>
                    <div className="row ra-hire-management-plan-view__container">
                        <div className="grid-view__body">
                            <div className="container-fluid">
                                {modal}
                                <div className="row">
                                    <div className="col-xs-12">{content}</div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 ra-hire-management-plan-view__footer">
                                        {footer}
                                        {commisionCondition}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">{successFooter}</div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }

        const ffUsPersonRoboadvisorHireUs = flagBasedFeatures.get(
            'wealth_roboadvisor_hire_us_person',
        );

        const contentRender = (
            <div className="ra-hire-management-plan-view grid-view">
                {contentSection}
            </div>
        );

        return (
            <ModalUsPersonBlock
                children={contentRender}
                featureFlag={ffUsPersonRoboadvisorHireUs}
                titleKey={'us_person_popup-roboadvisor_hire_us_title'}
                description={'us_person_popup-roboadvisor_hire_us_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_ROBO_URL)}
            />
        );
    }
}

RAHireManagementPlanView.propTypes = {
    changeTransferFundsAccount: PropTypes.func.isRequired,
    changeInvestmentType: PropTypes.func.isRequired,
    configureUserEmail: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immExpectedProfitability: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    immHireManagementPlan: PropTypes.object.isRequired,
    immManagementPlan: PropTypes.object.isRequired,
    immPortfolioDistribution: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immProfileEditor: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immSimulation: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    enableDisclaimerCheck: PropTypes.func.isRequired,
    getBlockedAccounts: PropTypes.func.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    fetchFeatureFlag: PropTypes.func.isRequired,
    finish: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    resetSuitabilityTest: PropTypes.func.isRequired,
    resetStep: PropTypes.func.isRequired,
    updateSelectedAccountsWithFunds: PropTypes.func.isRequired,
    updateSelectedFundsTotal: PropTypes.func.isRequired,
    setInvestmentAmount: PropTypes.func.isRequired,
    setSelectedAccount: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    toggleDisclaimer: PropTypes.func.isRequired,
    getPDFContract: PropTypes.func.isRequired,
    getExplicitImplicitCosts: PropTypes.func.isRequired,
    requestPortfolioDistribution: PropTypes.func.isRequired,
    setPeriodicity: PropTypes.func.isRequired,
    setRecurringContributionAmount: PropTypes.func.isRequired,
    setContributionDay: PropTypes.func.isRequired,
    validateCalendarStep: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    sendMail: PropTypes.func.isRequired,
    resetPreContractualMail: PropTypes.func.isRequired,
    requestSimulation: PropTypes.func.isRequired,
    getTestResult: PropTypes.func.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    getHirePlanConfirmationPDF: PropTypes.func.isRequired,
    saveTermsAndConditions: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        flagBasedFeatures: state.flagBasedFeatures,
        immAccounts: state.accounts,
        immExpectedProfitability: state.raExpectedProfitability,
        immGlobalPosition: state.raGlobalPosition,
        immHireManagementPlan: state.raHireManagementPlan,
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immPrinter: state.printer,
        immProfile: state.profile,
        immProfileEditor: state.profileEditor,
        immSignaturePattern: state.signaturePattern,
        immSimulation: state.raSimulation,
        immSuitabilityTest: state.raSuitabilityTest,
        immPreContractualMail: state.preContractualMail,
        immGlobalVariables: state.globalVariables.get('variables'),
        immCheckStatus: state.raCheckStatus,
    }),
    {
        changeTransferFundsAccount:
            raHireManagementPlanActions.changeTransferFundsAccount,
        changeInvestmentType: raHireManagementPlanActions.changeInvestmentType,
        configureUserEmail: raHireManagementPlanActions.configureUserEmail,
        enableDisclaimerCheck:
            raHireManagementPlanActions.enableDisclaimerCheck,
        getBlockedAccounts: blockedAccountsActions.getBlockedAccounts,
        resetBlockedAccounts: blockedAccountsActions.resetBlockedAccounts,
        fetchFeatureFlag: RAFeatureFlagActions.fetchFeatureFlag,
        finish: raHireManagementPlanActions.finish,
        reset: raHireManagementPlanActions.reset,
        resetStep: raHireManagementPlanActions.resetStep,
        resetSuitabilityTest: suitabilityActions.reset,
        updateSelectedAccountsWithFunds:
            raHireManagementPlanActions.updateSelectedAccountsWithFunds,
        updateSelectedFundsTotal:
            raHireManagementPlanActions.updateSelectedFundsTotal,
        setInvestmentAmount: raHireManagementPlanActions.setInvestmentAmount,
        setSelectedAccount: raHireManagementPlanActions.setSelectedAccount,
        setVisibleStep: raHireManagementPlanActions.setVisibleStep,
        setContributionDay: raHireManagementPlanActions.setContributionDay,
        requestSimulation: raSimulationActions.requestSimulation,
        setPeriodicity: raHireManagementPlanActions.setPeriodicity,
        setRecurringContributionAmount:
            raHireManagementPlanActions.setRecurringContributionAmount,
        validateStep: raHireManagementPlanActions.validateStep,
        toggleDisclaimer: raHireManagementPlanActions.toggleDisclaimer,
        getPDFContract: raHireManagementPlanActions.getPDFContract,
        getExplicitImplicitCosts:
            raHireManagementPlanActions.getExplicitImplicitCosts,
        requestPortfolioDistribution:
            portfolioDistributionActions.requestPortfolioDistribution,
        validateCalendarStep: raHireManagementPlanActions.validateCalendarStep,
        requestProfile: profileActions.requestProfile,
        sendMail: preContractualMailInfoActions.sendRoboHirePrecontractualMail,
        resetPreContractualMail:
            preContractualMailInfoActions.resetPrecontractualMail,
        getTestResult: suitabilityActions.getTestResult,
        getHirePlanConfirmationPDF:
            raHireManagementPlanActions.getHirePlanConfirmationPDF,
        saveTermsAndConditions:
            raHireManagementPlanActions.saveTermsAndConditions,
    },
)(withRouter(RAHireManagementPlanView));
